/**
 * File: fr_FR.js
 * Project: Noname-Base-Frontend
 * File Created: Friday, 25th October 2024 11:40:55 am
 * Author: Daniel Rodríguez Cabrera (daniel.rodriguez@aerin.es)
 * Version: 2.0.0
 * -----
 * Last Modified: Monday, 4th August 2025 1:29:28 pm
 * Modified By: Alexandru Ionut Dascalu
 * -----
 * Copyright (c) 2023 - 2024 Aerin Sistemas S. L. copying, distribution or modification not authorised in writing is prohibited.
 */

/* Textes de langue Gogo

Table des matières

01.Général
02.Connexion, déconnexion, inscription de l'utilisateur
03.Menu
04.Tableaux de bord
05.Pages
06.Applications
  06.01.Chat
  06.02.Sondage
  06.03.Tâches à faire
07.UI
  07.01.Alertes
  07.02.Badges
  07.03.Boutons
  07.04.Cartes
  07.05.Carrousel
  07.06.Graphiques
  07.07.Réduire
  07.08.Menus déroulants
  07.09.Éditeurs
  07.10.Formulaires
  07.11.Composants de formulaire
  07.12.Icônes
  07.13.Groupes de champs d'entrée
  07.14.Jumbotron
  07.15.Modal
  07.16.Navigation
  07.17.Popover & Info-bulle
  07.18.Triable
  07.19.Cartes
  07.20.Tableaux
  07.21.Assistants
  07.22.Erreurs
*/

module.exports = {
  /* 01.General */
  'general.copyright': 'Noname © 2022 Tous droits réservés.',
  'general.project-name': 'NONAME',

  'unauthorized.title': 'Tentative d’accès non autorisé',
  'unauthorized.detail':
    'Vous n’êtes pas autorisé à consulter la page que vous tentez d’atteindre.',

  /* 02.Connexion utilisateur, déconnexion, inscription */
  'user.login-title': 'Se connecter',
  'user.register': 'Inscription',
  'user.forgot-password': 'Vous avez oublié votre mot de passe ?',
  'user.email': 'Email',
  'user.password': 'Mot de passe',
  'user.forgot-password-question': 'Mot de passe oublié ?',
  'user.fullname': 'Nom complet',
  'user.login-button': 'SE CONNECTER',
  'user.login-sso': 'Se connecter avec SSO',
  'user.sso-redirecting': 'Redirection...',
  'user.sso-authenticating': 'Authentification...',
  'user.sso-error':
    "La connexion SSO a échoué. Vérifiez que votre utilisateur a accès à l'application ou connectez-vous avec identifiant et mot de passe.",
  'user.sso-error-user-not-found':
    "Votre compte n'est pas enregistré dans l'application. Contactez l'administrateur pour obtenir l'accès.",
  'user.sso-error-inactive':
    "Votre utilisateur est désactivé. Contactez l'administrateur.",
  'user.register-button': 'S’INSCRIRE',
  'user.reset-password-button': 'RÉINITIALISER',
  'user.buy': 'ACHETER',
  'user.username': "Nom d'utilisateur",
  'user.new-password-again': 'Nouveau mot de passe à nouveau',
  'user.new-password': 'Nouveau mot de passe',
  'user.reset-password': 'Réinitialiser le mot de passe',
  'user.warning-message':
    'Veuillez utiliser vos identifiants pour vous connecter.',
  'user.error.internal-server':
    'Erreur interne du serveur. Veuillez réessayer plus tard.',
  'user.error.invalid-credentials':
    'Identifiants invalides. Veuillez vérifier votre nom d’utilisateur et votre mot de passe.',
  'user.error.generic': 'Une erreur s’est produite. Veuillez réessayer.',
  'user.error.no-response':
    'Aucune réponse du serveur. Veuillez vérifier votre connexion ou réessayer plus tard.',
  'user.error.config-request': 'Erreur de configuration de la requête.',
  'user.error.login': 'Erreur de connexion.',
  'user.error.expired-token': 'Jeton de session expiré.',

  /* 03.Menu */
  'menu.home': 'Accueil',
  'menu.app': 'Accueil',
  'menu.dashboards': 'Tableaux de bord',
  'menu.default': 'Défaut',
  'menu.analytics': 'Analytique',
  'menu.ecommerce': 'E-commerce',
  'menu.content': 'Contenu',
  'menu.pages': 'Pages',
  'menu.administration': 'Administration',
  'menu.audits': 'Audits',
  'menu.accounts': 'Utilisateurs',
  'menu.data-list': 'Liste de données',
  'menu.thumb-list': 'Liste de vignettes',
  'menu.image-list': 'Liste d’images',
  'menu.details': 'Détails',
  'menu.search': 'Recherche',
  'menu.login': 'Connexion',
  'menu.register': 'Inscription',
  'menu.forgot-password': 'Mot de passe oublié',
  'menu.reset-password': 'Réinitialiser le mot de passe',
  'menu.error': 'Erreur',
  'menu.applications': 'Applications',
  'menu.todo': 'Notes',
  'menu.survey': 'Enquête',
  'menu.chat': 'Chat',
  'menu.ui': 'UI',
  'menu.alerts': 'Alertes',
  'menu.badges': 'Badges',
  'menu.buttons': 'Boutons',
  'menu.cards': 'Cartes',
  'menu.carousel': 'Carrousel',
  'menu.charts': 'Graphiques',
  'menu.collapse': 'Collapse',
  'menu.dropdowns': 'Menus déroulants',
  'menu.editors': 'Éditeurs',
  'menu.form-layouts': 'Mises en page de formulaire',
  'menu.form-components': 'Composants de formulaire',
  'menu.form-validations': 'Validations de formulaire',
  'menu.form-wizard': 'Assistant de formulaire',
  'menu.icons': 'Icônes',
  'menu.input-groups': 'Groupes de saisie',
  'menu.jumbotron': 'Jumbotron',
  'menu.modal': 'Modal',
  'menu.navigation': 'Navigation',
  'menu.popover-tooltip': 'Tooltips et Popovers',
  'menu.sortable': 'Triable',
  'menu.tables': 'Tables',
  'menu.menu': 'Menu',
  'menu.subhidden': 'Sous masqué',
  'menu.hidden': 'Masqué',
  'menu.visible': 'Visible',
  'menu.maps': 'Cartes',
  'menu.landingpage': 'Page d’accueil',
  'menu.multipage-home': 'Page multiple',
  'menu.singlepage-home': 'Page unique',
  'menu.about': 'À propos',
  'menu.auth-login': 'Authentification',
  'menu.auth-register': 'Inscription',
  'menu.blog': 'Blog',
  'menu.blog-list': 'Liste du blog',
  'menu.blog-detail': 'Détail du blog',
  'menu.careers': 'Carrières',
  'menu.confirmation': 'Confirmation',
  'menu.contact': 'Contact',
  'menu.docs': 'Docs',
  'menu.features': 'Fonctionnalités',
  'menu.prices': 'Tarifs',
  'menu.videos': 'Vidéos',
  'menu.mailing': 'Courriel',
  'menu.invoice': 'Facture',
  'menu.blank-page': 'Page vide',
  'menu.types': 'Types de menu',
  'menu.levels': 'Niveaux de menu',
  'menu.third-level-1': 'Troisième niveau 1',
  'menu.third-level-2': 'Troisième niveau 2',
  'menu.third-level-3': 'Troisième niveau 3',
  'menu.faq': 'FAQ',
  'menu.knowledge-base': 'Base de connaissances',
  'menu.authorization': 'Autorisation',
  'menu.profile': 'Profil',
  'menu.product': 'Produit',
  'menu.miscellaneous': 'Divers',
  'menu.portfolio': 'Portfolio',
  'menu.social': 'Social',
  'menu.details-alt': 'Détails alt',
  'menu.forms': 'Formulaire',
  'menu.components': 'Composants',
  'menu.layouts': 'Mises en page',
  'menu.validations': 'Validations',
  'menu.wizard': 'Assistant de configuration',

  /* Administration.accounts */
  'administration.accounts.create': 'Créer',
  'administration.accounts.cancel': 'Annuler',
  'administration.accounts.tittle.create': 'Créer un nouvel utilisateur',
  'administration.accounts.username': "Nom d'utilisateur",
  'administration.accounts.email': 'Email',
  'administration.accounts.name': 'Prénom',
  'administration.accounts.lastname': 'Nom de famille',
  'administration.accounts.password': 'Mot de passe',
  'administration.accounts.confirmpassword': 'Confirmer le mot de passe',
  'administration.accounts.staff': 'Personnel',
  'administration.accounts.administrator': 'Administrateur',
  'administration.accounts.edit': 'Modifier',
  'administration.accounts.delete': 'Supprimer',

  /* Administration.audits */
  'administration.audits.criticality': 'Criticité',
  'administration.audits.date': 'Date',
  'administration.audits.app': 'Application',
  'administration.audits.application': "Nom de l'application",
  'administration.audits.message': 'Message',

  /* 04.Tableaux */
  'dashboards.pending-orders': 'Commandes en attente',
  'dashboards.completed-orders': 'Commandes terminées',
  'dashboards.refund-requests': 'Demande de remboursement',
  'dashboards.new-comments': 'Nouveaux commentaires',
  'dashboards.sales': 'Ventes',
  'dashboards.orders': 'Commandes',
  'dashboards.refunds': 'Remboursement',
  'dashboards.recent-orders': 'Commandes récentes',
  'dashboards.product-categories': 'Catégories de produits',
  'dashboards.cakes': 'Gâteaux',
  'dashboards.tickets': 'Billets',
  'dashboards.calendar': 'Calendrier',
  'dashboards.best-sellers': 'Meilleures ventes',
  'dashboards.website-visits': 'Visites du site',
  'dashboards.unique-visitors': 'Visiteurs uniques',
  'dashboards.this-week': 'Cette semaine',
  'dashboards.last-week': 'La semaine dernière',
  'dashboards.this-month': 'Ce mois-ci',
  'dashboards.conversion-rates': 'Taux de conversion',
  'dashboards.per-session': 'Par session',
  'dashboards.profile-status': 'État du profil',
  'dashboards.payment-status': 'État du paiement',
  'dashboards.work-progress': 'Travail en cours',
  'dashboards.tasks-completed': 'Tâches terminées',
  'dashboards.payments-done': 'Paiements effectués',
  'dashboards.order-stock': 'Commandes - Stocks',
  'dashboards.categories': 'Catégories',
  'dashboards.quick-post': 'Publication rapide',
  'dashboards.title': 'Titre',
  'dashboards.content': 'Contenu',
  'dashboards.category': 'Catégorie',
  'dashboards.save-and-publish': 'Enregistrer et publier',
  'dashboards.top-viewed-posts': 'Articles les plus vus',
  'dashboards.posts': 'Articles',
  'dashboards.pending-for-publish': 'En attente de publication',
  'dashboards.users': 'Utilisateurs',
  'dashboards.on-approval-process': 'En cours d’approbation',
  'dashboards.alerts': 'Alertes',
  'dashboards.waiting-for-notice': 'En attente de notification',
  'dashboards.files': 'Fichiers',
  'dashboards.pending-for-print': 'En attente d’impression',
  'dashboards.logs': 'Journaux',
  'dashboards.gogo': 'GOGO',
  'dashboards.magic-is-in-the-details': 'LA MAGIE EST DANS LES DÉTAILS',
  'dashboards.yes-it-is-indeed': 'Oui, en effet !',
  'dashboards.advanced-search': 'Recherche avancée',
  'dashboards.toppings': 'Garnitures',
  'dashboards.type': 'Catégorie',
  'dashboards.keyword': 'Mot-clé',
  'dashboards.search': 'Recherche',
  'dashboards.top-rated-items': 'Articles les mieux notés',

  /* 05.Schémas */
  'pages.add-new': 'AJOUTER NOUVEAU',
  'pages.add-new-modal-title': 'Ajouter un nouvel élément',
  'pages.display-options': 'Options d’affichage',
  'pages.orderby': 'Trier par : ',
  'pages.total': 'Total : ',
  'pages.viewing': 'Affichage : ',
  'pages.product-name': 'Nom du produit',
  'pages.category': 'Catégorie',
  'pages.description': 'Description',
  'pages.status': 'Statut',
  'pages.cancel': 'Annuler',
  'pages.submit': 'Soumettre',
  'pages.delete': 'Supprimer',
  'pages.another-action': 'Autre action',
  'pages.actions': 'ACTIONS',
  'pages.header': 'En-tête',
  'pages.details': 'DÉTAILS',
  'pages.orders': 'COMMANDES',
  'pages.rating': 'Évaluation',
  'pages.price': 'Prix',
  'pages.ingredients': 'Ingrédients',
  'pages.is-vegan': 'Est végan',
  'pages.order-status': 'Statut de la commande',
  'pages.bake-progress': 'Progression de la cuisson',
  'pages.popularity': 'Popularité',
  'pages.comments': 'Commentaires',
  'pages.error-title': 'Oups, une erreur est survenue !',
  'pages.error-code': 'Code d’erreur',
  'pages.go-back-home': 'RETOURNER À L’ACCUEIL',
  'pages.mailing-info':
    'Les modèles de courrier utilisent une mise en page en ligne et basée sur des tableaux pour s’afficher correctement sur divers fournisseurs de services. Pour une meilleure convivialité, nous l’incluons en HTML régulier avec dangerouslySetInnerHTML.',
  'pages.invoice-info':
    'Le modèle de facture dispose d’une version en ligne pour une utilisation hors projet ainsi que d’une version React.',
  'pages.react-version': 'Version React',
  'pages.inline-version': 'Version HTML en ligne',
  'pages.like': 'J’aime',
  'pages.likes': 'J’aime',
  'pages.details-title': 'Détails',
  'pages.comments-title': 'Commentaires',
  'pages.questions-title': 'Questions',
  'pages.similar-projects': 'Projets similaires',
  'pages.send': 'Envoyer',
  'pages.addComment': 'Ajouter un commentaire',
  'pages.location': 'Emplacement',
  'pages.responsibilities': 'Responsabilités',
  'pages.photos': 'Photos',
  'pages.who-to-follow': 'Qui suivre',
  'pages.follow': 'SUIVRE',
  'pages.followers': 'ABONNÉS',
  'pages.recent-posts': 'Articles récents',
  'pages.profile': 'PROFIL',
  'pages.friends': 'AMIS',
  'pages.images': 'IMAGES',
  'pages.purchase': 'ACHETER',
  'pages.price.developer': 'DÉVELOPPEUR',
  'pages.price.team': 'ÉQUIPE',
  'pages.price.enterprise': 'ENTREPRISE',
  'pages.price.twofactorauthentication': 'Authentification à deux facteurs',
  'pages.price.teampermissions': 'Autorisations de l’équipe',
  'pages.price.245Support': 'Support 24/5',
  'pages.price.247Support': 'Support 24/7',
  'pages.price.useractionsauditlog': 'Journal des actions de l’utilisateur',
  'pages.prices.featurecomparison': 'Comparaison des fonctionnalités',
  'pages.prices.pricecomparison': 'Comparaison des prix',

  /* 06.Applications */

  /* 06.01.Chat */
  'chat.messages': 'Messages',
  'chat.contacts': 'Contacts',
  'chat.saysomething': 'Dis quelque chose...',

  /* 06.02.Sondage */
  'survey.delete': 'Supprimer',
  'survey.edit': 'Modifier',
  'survey.add-new': 'AJOUTER NOUVEAU',
  'survey.add-new-title': 'Ajouter un nouveau sondage',
  'survey.title': 'Titre',
  'survey.category': 'Catégorie',
  'survey.label': 'Étiquette',
  'survey.status': 'Statut',
  'survey.cancel': 'Annuler',
  'survey.submit': 'Envoyer',
  'survey.another-action': 'Autre action',
  'survey.display-options': 'Options d’affichage',
  'survey.orderby': 'Trier par : ',
  'survey.all-surveys': 'Tous les sondages',
  'survey.completed-surveys': 'Sondages complétés',
  'survey.categories': 'Catégories',
  'survey.active-surveys': 'Sondages actifs',
  'survey.labels': 'Étiquettes',

  /* 06.03.Notes */
  'todo.add-new': 'AJOUTER NOUVEAU',
  'todo.add-new-title': 'Ajouter Nouveau',
  'todo.title': 'Titre',
  'todo.detail': 'Détail',
  'todo.category': 'Catégorie',
  'todo.label': 'Étiquette',
  'todo.status': 'Statut',
  'todo.cancel': 'Annuler',
  'todo.submit': 'Envoyer',
  'todo.action': 'Action',
  'todo.another-action': 'Autre action',
  'todo.display-options': 'Options d’affichage',
  'todo.orderby': 'Trier par : ',
  'todo.all-tasks': 'Toutes les tâches',
  'todo.pending-tasks': 'Tâches en attente',
  'todo.completed-tasks': 'Tâches terminées',
  'todo.categories': 'Catégories',
  'todo.labels': 'Étiquettes',

  /* 07.IU */

  /* 07.01.Alertes */
  'alert.rounded': 'Alerte Arrondie',
  'alert.react-notifications': 'Notifications React',
  'alert.outline': 'Contour',
  'alert.primary': 'Primaire',
  'alert.secondary': 'Secondaire',
  'alert.info': 'Info',
  'alert.success': 'Succès',
  'alert.warning': 'Avertissement',
  'alert.error': 'Erreur',
  'alert.filled': 'Rempli',
  'alert.primary-text': 'Ceci est une alerte primaire — vérifiez !',
  'alert.secondary-text': 'Ceci est une alerte secondaire — vérifiez !',
  'alert.success-text': 'Ceci est une alerte de succès — vérifiez !',
  'alert.danger-text': 'Ceci est une alerte de danger — vérifiez !',
  'alert.warning-text': "Ceci est une alerte d'avertissement — vérifiez !",
  'alert.info-text': "Ceci est une alerte d'information — vérifiez !",
  'alert.light-text': 'Ceci est une alerte claire — vérifiez !',
  'alert.dark-text': 'Ceci est une alerte sombre — vérifiez !',
  'alert.default': 'Alerte par défaut',
  'alert.dismissing': 'Rejet de l’alerte',
  'alert.dismissing-text':
    'Sacrebleu ! Veuillez vérifier certains champs ci-dessous.',
  'alert.dismissing-without-animate-text':
    "Je suis une alerte qu'on peut rejeter sans animation !",

  /* 07.02.Badges */
  'badge.sizes': 'Tailles',
  'badge.colors': 'Couleurs',
  'badge.outline': 'Contour',
  'badge.links': 'Liens',
  'badge.counter-badges': 'Badges de compteur',
  'badge.bootstrap-default': 'Bootstrap Par Défaut',
  'badge.primary': 'Primaire',
  'badge.secondary': 'Secondaire',
  'badge.success': 'Succès',
  'badge.danger': 'Danger',
  'badge.warning': 'Avertissement',
  'badge.info': 'Info',
  'badge.light': 'Clair',
  'badge.dark': 'Sombre',

  /* 07.03.Boutons */
  'button.default': 'Bootstrap Par Défaut',
  'button.colors': 'Couleurs',
  'button.rounded': 'Boutons Arrondis',
  'button.outline': 'Contour',
  'button.states': 'États',
  'button.sizes': 'Tailles',
  'button.button-groups': 'Groupes de Boutons',
  'button.large-button': 'Grand Bouton',
  'button.small-button': 'Petit Bouton',
  'button.extra-small-button': 'Très Petit Bouton',
  'button.block-button': 'Bouton Bloc',
  'button.active': 'Actif',
  'button.disabled': 'Désactivé',
  'button.basic': 'Basique',
  'button.toolbar': 'Barre d’Outils',
  'button.nesting': 'Imbrication',
  'button.vertical-variation': 'Variation Verticale',
  'button.checkbox-radio-button': 'Cases à Cocher et Boutons Radio',
  'button.checkbox': 'Case à Cocher',
  'button.radio': 'Radio',
  'button.radio-button': 'Bouton Radio',
  'button.primary': 'Principal',
  'button.secondary': 'Secondaire',
  'button.success': 'Succès',
  'button.danger': 'Danger',
  'button.warning': 'Avertissement',
  'button.info': 'Info',
  'button.light': 'Clair',
  'button.dark': 'Sombre',
  'button.states-text':
    'Ce bouton affiche un indicateur de chargement pendant 2 secondes et une icône d’erreur pendant 3 secondes avant de revenir à l’état normal. Ces états peuvent être activés en ajoutant et supprimant des classes.',
  'button.click-here': 'Cliquez ici',
  'button.states-text-alternate':
    'Ce bouton affiche un indicateur de chargement pendant 2 secondes et une icône d’erreur pendant 3 secondes avant de revenir à l’état normal. Ces états peuvent être activés en ajoutant et supprimant des classes.',
  'button.primary-link': 'Lien Principal',
  'button.link': 'Lien',
  'button.primary-button': 'Bouton Principal',
  'button.button': 'Bouton',
  'button.left': 'Gauche',
  'button.middle': 'Centre',
  'button.right': 'Droite',
  'button.dropdown': 'Menu déroulant',
  'button.dropdown-link': 'Lien déroulant',

  /* 07.04.Cartes */
  'cards.icon-card': 'Carte d’Icône',
  'cards.image-card': 'Carte d’Image',
  'cards.image-overlay-card': 'Carte avec Superposition d’Image',
  'cards.image-card-list': 'Liste de Cartes d’Image',
  'cards.tab-card': 'Carte à Onglets',
  'cards.user-card': 'Carte Utilisateur',

  /* 07.05.Carrousel */
  'carousel.basic': 'Carrousel de Base',
  'carousel.single': 'Carrousel Unique',
  'carousel.without-controls': 'Carrousel sans Contrôles',

  /* 07.06.Graphiques */
  'charts.line': 'Graphique Linéaire',
  'charts.polar': 'Graphique Polaire',
  'charts.area': 'Graphique de Surface',
  'charts.scatter': 'Graphique de Dispersion',
  'charts.bar': 'Graphique à Barres',
  'charts.radar': 'Graphique Radar',
  'charts.pie': 'Graphique Circulaire',
  'charts.doughnut': 'Graphique en Anneau',
  'charts.shadow': 'Ombre',
  'charts.no-shadow': 'Sans Ombre',

  /* 07.07.Collapse */
  'collapse.basic': 'Basique',
  'collapse.toggle': 'Commutateur',
  'collapse.accordion': 'Accordéon',
  'collapse.controlled': 'Contrôlé',
  'collapse.uncontrolled': 'Non Contrôlé',

  /* 07.08.Déroulants */
  'dropdowns.basic': 'Basique',
  'dropdowns.controlled': 'Contrôlé',
  'dropdowns.uncontrolled': 'Non Contrôlé',
  'dropdowns.dropdown': 'Menu Déroulant',
  'dropdowns.header': 'En-tête',
  'dropdowns.action': 'Action',
  'dropdowns.another-action': 'Autre action',
  'dropdowns.right': 'Droite',
  'dropdowns.left': 'Gauche',
  'dropdowns.drop-directions': 'Directions de menu',
  'dropdowns.dropright': 'Menu vers la droite',
  'dropdowns.dropleft': 'Menu vers la gauche',
  'dropdowns.small-button': 'Petit Bouton',
  'dropdowns.large-button': 'Grand Bouton',
  'dropdowns.sizing': 'Dimensionnement',
  'dropdowns.split-button': 'Boutons Scindés',
  'dropdowns.dropup': 'Menu vers le haut',

  /* 07.09.Éditeurs */
  'editors.draftjs': 'Draft.js',
  'editors.quill-standart': 'Quill Standard',
  'editors.quill-bubble': 'Quill Bulle',

  /* 07.10.Formulaires */
  'forms.basic': 'Basique',
  'forms.email': 'Email',
  'forms.email-muted':
    'Nous ne partagerons jamais votre email avec qui que ce soit.',
  'forms.password': 'Mot de passe',
  'forms.password-confirm': 'Confirmer le mot de passe',
  'forms.submit': 'Soumettre',
  'forms.horizontal': 'Horizontal',
  'forms.radios': 'Boutons Radio',
  'forms.first-radio': 'Premier bouton radio',
  'forms.second-radio': 'Deuxième bouton radio',
  'forms.third-radio-disabled': 'Troisième bouton radio désactivé',
  'forms.checkbox': 'Case à cocher',
  'forms.signin': 'Se connecter',
  'forms.top-labels-over-line': 'Étiquettes au-dessus de la ligne',
  'forms.tags': 'Étiquettes',
  'forms.date': 'Date',
  'forms.state': 'État',
  'forms.top-labels-in-input': 'Étiquettes dans les champs',
  'forms.email-u': 'EMAIL',
  'forms.password-u': 'MOT DE PASSE',
  'forms.tags-u': 'ÉTIQUETTES',
  'forms.date-u': 'DATE',
  'forms.state-u': 'ÉTAT',
  'forms.grid': 'Grille de formulaire',
  'forms.address': 'Adresse',
  'forms.address2': 'Adresse 2',
  'forms.city': 'Ville',
  'forms.city-message': 'Veuillez sélectionner une ville !',
  'forms.state-message': 'Veuillez sélectionner un état !',
  'forms.zip': 'Code Postal',
  'forms.signup': 'Inscription',
  'forms.inline': 'En ligne',
  'forms.validation': 'Validation',
  'forms.default': 'Défaut',
  'forms.firstname': 'Prénom',
  'forms.firstname-message': 'Veuillez entrer votre prénom !',
  'forms.lastname': 'Nom',
  'forms.lastname-message': 'Veuillez entrer votre nom !',
  'forms.name': 'Nom',
  'forms.validation-availity': 'Validation Availity Reactstrap',
  'forms.validation-formik': 'Validation Formik',

  /* 07.11.Composants de Formulaire */
  'form-components.custom-inputs': 'Entrée Personnalisée',
  'form-components.checkboxes': 'Cases à cocher',
  'form-components.radios': 'Boutons Radio',
  'form-components.inline': 'En ligne',
  'form-components.react-select': 'React Select',
  'form-components.state-single': 'État Unique',
  'form-components.state-multiple': 'État Multiple',
  'form-components.react-autosuggest': 'React Autosuggest',
  'form-components.date-picker': 'Sélecteur de Date',
  'form-components.date': 'Date',
  'form-components.date-range': 'Plage de Dates',
  'form-components.date-with-time': 'Date avec Heure',
  'form-components.embedded': 'Intégré',
  'form-components.dropzone': 'Dropzone',
  'form-components.drop-files-here': 'Déposez les fichiers ici',
  'form-components.tags': 'Étiquettes',
  'form-components.switch': 'Interrupteur',
  'form-components.primary': 'Primaire',
  'form-components.secondary': 'Secondaire',
  'form-components.primary-inverse': 'Primaire Inversé',
  'form-components.secondary-inverse': 'Secondaire Inversé',
  'form-components.slider': 'Curseur',
  'form-components.double-slider': 'Double Curseur',
  'form-components.single-slider': 'Curseur Simple',
  'form-components.rating': 'Évaluation',
  'form-components.interactive': 'Interactif',
  'form-components.readonly': 'Lecture Seule',
  'form-components.type-a-cake': 'Tapez un gâteau',
  'form-components.start': 'Début',
  'form-components.end': 'Fin',
  'form-components.tables': 'Tableaux',

  /* 07.12.Icônes */
  'icons.simplelineicons': 'Icônes Simple Line',
  'icons.iconsmind': 'Icônes IconsMind',

  /* 07.13.Groupes de Saisie */
  'input-groups.basic': 'De base',
  'input-groups.sizing': 'Dimensionnement',
  'input-groups.small': 'Petit',
  'input-groups.default': 'Défaut',
  'input-groups.large': 'Grand',
  'input-groups.checkboxes-and-radios': 'Cases à cocher et boutons radio',
  'input-groups.multiple-inputs': 'Entrées Multiples',
  'input-groups.first-and-last-name': 'Nom et prénom',
  'input-groups.multiple-addons': 'Compléments Multiples',
  'input-groups.button-addons': 'Compléments de Bouton',
  'input-groups.button': 'Bouton',
  'input-groups.buttons-with-dropdowns': 'Boutons et Menus Déroulants',
  'input-groups.dropdown': 'Menu Déroulant',
  'input-groups.header': 'En-tête',
  'input-groups.action': 'Action',
  'input-groups.another-action': 'Autre action',
  'input-groups.custom-select': 'Sélection Personnalisée',
  'input-groups.options': 'Options',
  'input-groups.choose': 'Choisir...',
  'input-groups.custom-file-input': 'Entrée de Fichier Personnalisée',

  /* 07.14.Jumbotron */
  'jumbotron.hello-world': 'Bonjour le monde !',
  'jumbotron.lead':
    'Ceci est une unité de héros simple, un composant de type jumbotron conçu pour attirer davantage l’attention sur du contenu ou des informations en vedette.',
  'jumbotron.lead-detail':
    'Utilisez les classes utilitaires de typographie et d’espacement pour espacer le contenu à l’intérieur du conteneur plus grand.',
  'jumbotron.learn-more': 'En savoir plus',

  /* 07.15.Modale */
  'modal.basic': 'De base',
  'modal.modal-title': 'Titre de la Modale',
  'modal.launch-demo-modal': 'Lancer la Démo Modale',
  'modal.scrolling-long-content': 'Contenu Défilant Long',
  'modal.backdrop': 'Arrière-plan',
  'modal.backdrop-value': 'Valeur de l’Arrière-plan',
  'modal.right-modal': 'Modale à Droite',
  'modal.launch-right-modal': 'Lancer la Modale à Droite',
  'modal.nested-modal': 'Modale Imbriquée',
  'modal.size': 'Taille',
  'modal.launch-large-modal': 'Lancer la Grande Modale',
  'modal.launch-small-modal': 'Lancer la Petite Modale',

  /* 07.16.Navigation */
  'nav.basic': 'Navigation de Base',
  'nav.active': 'Actif',
  'nav.disabled': 'Désactivé',
  'nav.disabled-link': 'Lien Désactivé',
  'nav.link': 'Lien',
  'nav.longer-link': 'Lien de navigation plus long',
  'nav.another-link': 'Autre Lien',
  'nav.right': 'Droite',
  'nav.dropdown': 'Menu Déroulant',
  'nav.header': 'En-tête',
  'nav.action': 'Action',
  'nav.another-action': 'Autre action',
  'nav.horizontal-alignment': 'Alignement Horizontal',
  'nav.vertical-alignment': 'Alignement Vertical',
  'nav.pills': 'Navigation en Pilules',
  'nav.fill-justify': 'Remplir et Justifier',
  'nav.pills-dropdowns': 'Pilules avec Menus Déroulants',
  'nav.pagination-basic': 'Pagination de Base',
  'nav.pagination-sizing': 'Dimensionnement de la Pagination',
  'nav.large': 'Grand',
  'nav.small': 'Petit',
  'nav.center': 'Centre',
  'nav.pagination-alignment': 'Alignement de la Pagination',
  'nav.breadcrumb-basic': 'Fil d’Ariane de Base',
  'nav.dark-mode': 'Mode Sombre',
  'nav.log-out': 'Se Déconnecter',
  'nav.maximize': 'Maximiser',

  /* 07.17.Info-bulles et Popovers */
  'popover-tooltip.popover': 'Popovers',
  'popover-tooltip.tooltip': 'Info-bulles',

  /* 07.18.Ordonnable */
  'sortable.columns': 'Colonnes Triables',
  'sortable.basic': 'Basique',
  'sortable.handles': 'Poignées',

  /* 07.19.Cartes */
  'maps.google': 'Google',
  'maps.yandex': 'Yandex',

  /* 07.20.Tables */
  'table.bootstrap-tables': 'Tables Bootstrap',
  'table.bootstrap-basic': 'Tables Basiques',
  'table.bootstrap-striped': 'Rayées',
  'table.bootstrap-bordered': 'Tables avec Bordures',
  'table.bootstrap-borderless': 'Tables sans Bordures',
  'table.bootstrap-hoverable': 'Tables Interactives',
  'table.bootstrap-responsive': 'Tables Responsives',
  'table.react-tables': 'Tables React',
  'table.react-pagination': 'Pagination',
  'table.react-scrollable': 'Tables Défilables',
  'table.react-advanced': 'Filtrage, Longueur et Saut',
  'table.divided': 'Table Divisée',

  /* 07.21.Assistants */
  'wizard.step-name-1': 'Étape 1',
  'wizard.step-name-2': 'Étape 2',
  'wizard.step-name-3': 'Étape 3',
  'wizard.step-desc-1': 'Description de la première étape',
  'wizard.step-desc-2': 'Description de la deuxième étape',
  'wizard.step-desc-3': 'Description de la troisième étape',
  'wizard.content-1': 'Contenu pour la première étape.',
  'wizard.content-2': 'Contenu pour la deuxième étape.',
  'wizard.content-3': 'Contenu pour la dernière étape !',
  'wizard.content-thanks': 'Merci !',
  'wizard.next': 'Suivant',
  'wizard.prev': 'Précédent',
  'wizard.registered': 'Votre inscription a été complétée avec succès !',
  'wizard.async': 'Sauvegarde asynchrone pendant 3 secondes !',

  /* 07.22.Erreurs */
  'error.401-not-authorized': "Erreur, la session de l'utilisateur a expiré.",
  'error.403-not-authorized':
    "Erreur, l'utilisateur n’a pas les permissions requises. Il est recommandé de se reconnecter pour obtenir les bons droits.",
  /* Modules */
  /* aiteaview_start_trans */
  'cosbim.name': 'COSBIM 360',
  'cosbim.description':
    "L'agence immobilière leader en bureaux de qualité dans la zone euro",
  'menu.cities': 'Villes',
  'menu.administration-cosbim': 'Administration',
  'menu.buildings': 'Bâtiments',
  'menu.building': 'Construire',
  'menu.widgets': 'Widgets',
  'menu.parameters': 'Paramètres',
  'menu.documents': 'Documents',
  'menu.cosbim': 'Cosbim',
  'menu.metasys': 'Metasys',
  'menu.download': 'Télécharger les données au format CSV',
  'menu.med': 'MED',
  'menu.alarms': 'Alarmes',
  'menu.settings': 'Paramètres',
  'administration.accounts.alarms.criticity_title':
    'Niveaux de criticité (Alarmes)',
  'administration.accounts.alarms.critical': 'Critique',
  'administration.accounts.alarms.warning': 'Avertissement',
  'administration.accounts.alarms.minor': 'Légère',
  'administration.accounts.alarms.informational': 'Informationnelle',
  'administration.groups.select-all': 'Tout sélectionner',
  'administration.groups.deselect-all': 'Effacer',
  'administration.profile': 'Profil',
  'administration.profile.edit.success': 'Utilisateur modifié avec succès',
  'administration.users': 'Utilisateurs',
  'administration.cities': 'Villes',
  'administration.buildings': 'Bâtiments',
  'administration.ocas': 'OCAs',
  'administration.ocas.name': 'Nom',
  'administration.ocas.royal_decree': 'Décret royal',
  'administration.ocas.periodicity': "Périodicité de l'inspection",
  'administration.ocas.create': 'Créer une nouvelle installation',
  'administration.ocas.edit': "Modifier l'installation",
  'administration.ocas.inspection_name': "Nom de l'inspection",
  'administration.ocas.royal_decree_name': 'Nom du décret royal',
  'administration.ocas.docuware_fields': 'Champs DocuWare',
  'administration.ocas.doc_class_field': 'Champ Classe doc',
  'administration.ocas.doc_subclass_field': 'Champ Sous-classe doc',
  'administration.ocas.date.missing': 'Manquant',
  'administration.ocas.filter.status': 'Statut',
  'administration.ocas.filter.status.all': 'Toutes les dates',
  'administration.ocas.filter.status.danger': 'Dates en rouge',
  'administration.ocas.filter.date': "Date d'inspection",
  'administration.ocas.installations': 'Installations ',
  'administration.ocas.current_year': 'Année en cours : ',
  'administration.ocas.download_excel': 'Télécharger excel',
  'administration.ocas.building.installation': 'Installation',
  'administration.ocas.building.regulation': 'Réglementation',
  'administration.ocas.building.status': 'Statut',
  'administration.ocas.building.next_inspection': 'Prochaine inspection',
  'administration.ocas.building.status.approved': 'Approuvée',
  'administration.ocas.building.status.conditioned': 'Conditionnée',
  'administration.ocas.building.status.rejected': 'Non approuvée',
  'administration.ocas.building.new_inspection_date':
    'Nouvelle date de prochaine inspection',
  'administration.ocas.building.conditioned_modal_title':
    "Passer à l'état conditionné",
  'administration.ocas.building.save': 'Enregistrer',
  'administration.widgets': 'Widgets',
  'administration.widgets.list.name': 'Nom',
  'administration.widgets.list.url': 'URL',
  'administration.widgets.list.type': 'Type',
  'administration.widgets.list.placement': 'Emplacement',
  'administration.widgets.list.position': 'Position',
  'administration.widgets.edit.tittle': 'Modifier le widget',
  'administration.widgets.edit.name': 'Nom du widget',
  'administration.widgets.list.kind': 'Famille',
  'administration.widgets.edit.kind': 'Famille du widget',
  'administration.widgets.edit.type': 'Type de widget',
  'administration.widgets.edit.placement': 'Emplacement du widget',
  'administration.widgets.edit.position': 'Position du widget',
  'administration.widgets.edit.url': 'URL du widget',
  'administration.widgets.edit.mobile_url': 'URL mobile du widget',
  'administration.widgets.edit.image': 'Image du widget',
  'administration.widgets.edit.groups': 'Groupes',
  'administration.widgets.edit.validation.error.title': 'Erreur de validation',
  'administration.widgets.edit.validation.error.message':
    'Veuillez compléter tous les champs obligatoires : nom, type, emplacement, position et URL',
  'administration.widgets.placement': 'Emplacement',
  'administration.widgets.image': 'Sélectionnez une image',
  'administration.widgets.portal': 'Portail',
  'administration.widgets.cosbim': 'Cosbim',
  'administration.widgets.planos': 'Plans',
  'administration.widgets.reports': 'Rapports',
  'administration.widgets.heatmap': 'Carte de chaleur',
  'administration.widgets.intranet': 'Intranet',
  'administration.widgets.climate': 'Climat',
  'administration.widgets.lightning': 'Éclairage',
  'administration.widgets.assistant': 'Assistance',
  'administration.widgets.electricidad': 'Électricité',
  'administration.widgets.agua': 'Eau',
  'administration.widgets.gas': 'Gaz',
  'administration.widgets.districlima': 'Districlima',
  'administration.widgets.co2': 'CO2',
  'administration.widgets.co2-ext': 'CO2 Ext.',
  'administration.widgets.cala': "Qualité de l'air",
  'administration.widgets.temperatura': 'Température',
  'administration.widgets.humedad': 'Humidité',
  'administration.widgets.afluencia': 'Afluencia',
  'administration.widgets.contacts': 'Contacts',
  'administration.settings': 'Paramètres',
  'administration.settings.portfolio-coords': 'Coordonnées',
  'administration.settings.latitude': 'Latitude',
  'administration.settings.longitude': 'Longitude',
  'administration.settings.market-value': 'Valeur de marché (€m)',
  'administration.settings.total-area': 'Surface totale (m²)',
  'administration.settings.total-buildings': 'Nombre de bâtiments',
  'administration.settings.portfolio-kpis': 'KPI du portefeuille',
  'administration.settings.email': "Email d'inscription",
  'administration.settings.csv': 'CSV Bâtiments',
  'administration.settings.upload.csv.datamaster':
    'Télécharger Données Principales CSV',
  'administration.settings.upload.csv.spacesclients':
    'Télécharger Espaces Clients CSV',
  'administration.settings.uploading': 'Téléchargement du fichier CSV...',
  'administration.settings.upload': 'Charger',
  'administration.settings.disclaimer.title': 'Disclaimers',
  'administration.settings.privacy.title': 'Politique de confidentialité',
  'administration.settings.legal.hint': 'Non affiché si laissé vide.',
  'administration.settings.legal.spanish': 'Texte en espagnol',
  'administration.settings.legal.english': 'Texte en anglais',
  'administration.settings.legal.cat': 'Texte en catalan',
  'administration.settings.legal.french': 'Texte en français',
  'administration.settings.contact.title': 'Contact',
  'administration.settings.contact.hint':
    "Si laissé vide, il n'y a pas de page de contact. Le formulaire n'apparaît qu'avec un e-mail.",
  'administration.settings.contact.address': 'Adresse',
  'administration.settings.contact.phone': 'Téléphone',
  'administration.settings.contact.hours': 'Horaires',
  'administration.settings.contact.email': 'E-mail de contact',
  'administration.settings.save': 'Enregistrer les paramètres',
  'administration.settings.scraper_config': 'Scraper KPI',
  'administration.settings.execution.title': "Type d'exécution",
  'administration.settings.execution.daily': 'Quotidien',
  'administration.settings.execution.weekly': 'Hebdomadaire',
  'administration.settings.execution.monthly': 'Mensuel',
  'administration.settings.day.week': 'Jour de la semaine',
  'administration.settings.day.month': 'Jour du mois',
  'administration.settings.select.day': 'Sélectionnez un jour',
  'administration.settings.notification.scraper_updated':
    'Configuration mise à jour avec succès',
  'administration.settings.notification.updated': 'Configuration mise à jour',
  'administration.settings.day.monday': 'Lundi',
  'administration.settings.day.tuesday': 'Mardi',
  'administration.settings.day.wednesday': 'Mercredi',
  'administration.settings.day.thursday': 'Jeudi',
  'administration.settings.day.friday': 'Vendredi',
  'administration.settings.day.saturday': 'Samedi',
  'administration.settings.day.sunday': 'Dimanche',
  'administration.scraper.save': 'Enregistrer la configuration du Scraper',
  'administration.settings.hide_scraper_config':
    'Masquer la configuration du Scraper KPI',
  'administration.settings.show_scraper_config':
    'Afficher la configuration du Scraper KPI',
  'administration.parameters': 'Paramètres',
  'administration.documents': 'Documents',
  'administration.documents.assignment': 'Assignation de documents',
  'administration.documents.assign': 'Assigner',
  'administration.documents.hide': 'Masquer',
  'administration.assign.users': 'Utilisateurs assignés',
  'administration.assign.cities': 'Villes assignées',
  'administration.assign.buildings': 'Bâtiments assignés',
  'administration.assign.widgets': 'Widgets assignés',
  'administration.assign.parameters': 'Paramètres assignés',
  'administration.assign.documents': 'Documents assignés',
  'administration.assign.clients': 'Clients assignés',
  'administration.permission.user': 'Permission',
  'administration.accounts.surname': 'Nom de famille',
  'administration.accounts.tittle.edit': "Modifier l'utilisateur",
  'administration.accounts.tittle.delete': 'Supprimer cet utilisateur ?',
  'administration.accounts.delete.success': 'Utilisateur supprimé avec succès',
  'administration.accounts.type': 'Type',
  'administration.accounts.auth.internal': 'Interne',
  'administration.accounts.auth.external': 'Externe',
  'administration.accounts.validated.password':
    'Le mot de passe doit contenir au moins 8 caractères, une majuscule, un chiffre et un caractère spécial',
  'administration.accounts.selector.language': 'Langue',
  'administration.accounts.selector.homescreen.placeholder':
    'Sélectionnez une page d’accueil...',
  'administration.accounts.selector.homescreen.portfolio': 'Portefeuille',
  'administration.accounts.selector.homescreen.space': 'Ville',
  'administration.accounts.selector.homescreen.building': 'Bâtiment',
  'administration.accounts.selector.homescreen.client': 'Client',
  'administration.accounts.selector.authtype': 'Type d’authentification',
  'administration.accounts.selector.authtype.placeholder':
    'Sélectionnez le type d’authentification...',
  'administration.accounts.selector.language.placeholder':
    'Sélectionnez une langue...',
  'administration.accounts.selector.widgets.placeholder':
    'Sélectionnez un widget...',
  'administration.accounts.myprofile.current_password': 'Mot de passe actuel',
  'administration.homescreen.portofolio': 'Portefeuille',
  'administration.homescreen.space': 'Ville',
  'administration.homescreen.building': 'Bâtiment',
  'administration.homescreen.client': 'Client',
  'administration.cities.tittle.create': 'Créer une nouvelle ville',
  'administration.cities.tittle.edit': 'Modifier la ville',
  'administration.city.tittle.delete': 'Supprimer cette ville ?',
  'administration.buildings.tittle.create': 'Créer un nouveau bâtiment',
  'administration.buildings.tittle.edit': 'Modifier le bâtiment',
  'administration.buildings.tittle.warning': 'Avertissement',
  'administration.buildings.tittle.delete': 'Supprimer ce bâtiment ?',
  'administration.buildings.tittle.accept': 'Accepter',
  'administration.buildings.image.delete': "Supprimer l'image",
  'administration.buildings.image.delete.body':
    "Voulez-vous supprimer l'image associée au client ",
  'administration.buildings.image.delete.success':
    'Image supprimée avec succès',
  'notification.success.title': 'Succès',
  'administration.buildings.create.success': 'Bâtiment créé avec succès',
  'administration.buildings.edit.success': 'Bâtiment modifié avec succès',
  'administration.buildings.longlat.validation':
    'La valeur doit être un nombre décimal avec un maximum de 3 chiffres entiers et 7 décimales.',
  'administration.buildings.required_fields':
    'Remplissez les champs obligatoires suivants :',
  'administration.buildings.fix_errors':
    "Corrigez les erreurs indiquées avant d'enregistrer.",
  'administration.buildings.invalid_link':
    'Le lien doit être une URL valide, commençant par http ou https.',
  'administration.buildings.tittle.cancel': 'Annuler',
  'administration.buildings.link.grafana':
    "Lien du tableau de bord d'occupation",
  'administration.buildings.occupation': "Données d'occupation",
  'administration.tittle.back': 'Retour',
  'administration.building.certification': 'Certification',
  'administration.widgets.tittle.create': 'Créer un nouveau widget',
  'administration.parameters.tittle.create': 'Créer un nouveau paramètre',
  'administration.widgets.tittle.edit': 'Modifier le widget',
  'administration.parameters.tittle.edit': 'Modifier le paramètre',
  'administration.widgets.tittle.delete': 'Supprimer ce widget ?',
  'administration.widgetConf.tittle.delete':
    'Supprimer cette configuration de widget ?',
  'administration.widgetConf.delete.success':
    'Configuration de widget supprimée avec succès',
  'administration.parameters.tittle.delete': 'Supprimer ce paramètre ?',
  'administration.documents.tittle.edit': 'Modifier le lien',
  'administration.document.edit.success': 'Lien modifié avec succès',
  'administration.widgets.position': "Position sur l'écran d'accueil",
  'administration.widgets.front_carusel': 'Carrousel avant',
  'administration.structure': 'Structure',
  'administration.widgets.url': 'URL',
  position: 'Position',
  'administration.assets': 'Type',
  'administration.img': 'Image du bâtiment',
  'administration.img.city': 'Image de la ville',
  'administration.img.widget': 'Image du widget',
  img: 'Image',
  'administration.accounts.superuser': 'Super utilisateur',
  'administration.accounts.user': 'Client',
  'administration.accounts.user.can.see.administration':
    "L'utilisateur peut voir l'administration",
  'administration.userRoles': "Rôles d'utilisateur",
  'administration.selectUserRole': "Sélectionner le rôle de l'utilisateur",
  'administration.selectUserRoleAssistant':
    'Vous devez sélectionner un rôle pour le widget Assistant',
  'filter.city': 'Filtrer par ville',
  'filter.assets': 'Filtrer par actifs',
  'filter.projects': 'Filtrer par projets',
  'filter.buildings': 'Filtrer par bâtiment',
  'filter.widgets': 'Filtrer par widgets',
  'select.assets': 'Actif',
  'select.projects': 'Projet',
  'module.name': 'Nom du module',
  'parameters.name': 'Nom du paramètre',
  'parameters.name.required': 'Le nom du dossier est obligatoire.',
  'parameters.url': 'Lien du document',
  'document.send': 'Envoyer des documents',
  'document.receiver': 'Destinataire',
  'document.subject': 'Sujet',
  'document.comment': 'Commentaire',
  'document.attached': 'Joindre des fichiers',
  'document.sending': 'Envoi du mail, veuillez patienter...',
  'document.sent': 'Mail envoyé avec succès',
  'select.building': 'Sélectionner un bâtiment',
  'url.sin.dato': "# si c'est un conteneur d'un autre niveau",
  'forms.message': 'Message',
  'alert.documents':
    'Vous devez sélectionner un bâtiment pour voir la documentation.',
  'dashboard.title': 'Surveillance énergétique',
  'forms.range': 'Plage de dates',
  'forms.year-range': "Plage d'années",
  'menu.consumption': 'Consommation',
  'air.quality': "Qualité de l'air",
  'air.quality.daily': "Qualité de l'air (quotidien)",
  'air.quality.monthly': "Qualité de l'air (mensuel)",
  'air.quality.yearly': "Qualité de l'air (annuel)",
  'air.quality.ext': 'Qualité air Ext.',
  'air.quality.history': "Historique Qualité de l'air",
  'air.co2': 'CO2',
  'air.co2.daily': 'CO2 (quotidien)',
  'air.co2.monthly': 'CO2 (mensuel)',
  'air.co2.yearly': 'CO2 (annuel)',
  'air.co2.ext': 'CO2 Ext.',
  'air.co2.history': 'Historique CO2',
  'air.co2.ext.history': 'Historique CO2 Ext.',
  'carbon.footprint': 'Empreinte Carbone',
  'carbon.footprint.history': 'Historique Empreinte Carbone',
  'metric.temperature-forecast': 'Prévision Température',
  'metric.occupation-evolution': 'Évol. occupation',
  'metric.occupation-percentage': 'Pourcentage d’affluence',
  'metric.occupation-maximum-daily': 'Occupation maximale quotidienne',
  'metric.bathroom-transit': 'Transit toilettes',
  'metric.alarms': 'Alarmes',
  'building.flows': 'Flux',
  'flows.view.real': 'Vue réelle',
  'flows.view.max': 'Vue des maximums',
  'flows.growth.previous_year': '(Année préc.)',
  'flows.growth.range_title': "Croissance de l'affluence totale",
  'chart.occupation': 'Occupation',
  'occupation.implantation': 'En implantation',
  'occupation.max_since_january': 'Valeur maximale depuis le 1er janvier',
  'meteorology.variables.internal': 'Interne',
  'meteorology.variables.external': 'Externe',
  'meteorology.year.to.date': 'Année en cours',
  'menu.floors': 'Étages',
  'menu.customers': 'Clients',
  'menu.office': 'Bureaux',
  'gas.consumption': 'Conso. de gaz',
  'gas.consumption.history': 'Historique de conso. de gaz',
  'gas.consumption.daily': 'Cons. Gaz (quotidien)',
  'gas.consumption.monthly': 'Cons. Gaz (mensuel)',
  'gas.consumption.yearly': 'Cons. Gaz (annuel)',
  'electrical.consumption': 'Conso. élec',
  'electrical.consumption.history': 'Historique de conso. élec',
  'electrical.consumption.daily': 'Cons. Électr. (quotidien)',
  'electrical.consumption.monthly': 'Cons. Électr. (mensuel)',
  'electrical.consumption.yearly': 'Cons. Électr. (annuel)',
  'electrical.consumption.symmetrical': 'Conso. élec sym.',
  'electrical.consumption.symmetrical.history':
    'Historique de conso. élec sym.',
  'electrical.consumption.symmetrical.daily': 'Cons. Électr. Sym. (quotidien)',
  'electrical.consumption.symmetrical.monthly': 'Cons. Électr. Sym. (mensuel)',
  'electrical.consumption.symmetrical.yearly': 'Cons. Électr. Sym. (annuel)',
  'water.consumption': 'Conso. d’eau',
  'water.consumption.history': 'Historique de conso. d’eau',
  'water.consumption.daily': 'Cons. Eau (quotidien)',
  'water.consumption.monthly': 'Cons. Eau (mensuel)',
  'water.consumption.yearly': 'Cons. Eau (annuel)',
  'districlima.consumption': 'DistriClima',
  'districlima.consumption.history': 'Historique DistriClima',
  'districlima.consumption.daily': 'DistriClima (total) (quotidien)',
  'districlima.consumption.monthly': 'DistriClima (total) (mensuel)',
  'districlima.consumption.yearly': 'DistriClima (total) (annuel)',
  'districlima.consumption.cold': 'DistriClima (froid)',
  'districlima.consumption.cold.daily': 'DistriClima (froid) (quotidien)',
  'districlima.consumption.cold.monthly': 'DistriClima (froid) (mensuel)',
  'districlima.consumption.cold.yearly': 'DistriClima (froid) (annuel)',
  'districlima.consumption.hot': 'DistriClima (chaleur)',
  'districlima.consumption.hot.daily': 'DistriClima (chaleur) (quotidien)',
  'districlima.consumption.hot.monthly': 'DistriClima (chaleur) (mensuel)',
  'districlima.consumption.hot.yearly': 'DistriClima (chaleur) (annuel)',
  'districlima.total': 'Total',
  'districlima.hot': 'Chaleur',
  'districlima.cold': 'Froid',
  'chart.temperature': 'Température',
  'chart.temperature.history': 'Historique de température',
  'chart.temperature.daily': 'Température (quotidien)',
  'chart.temperature.monthly': 'Température (mensuel)',
  'chart.temperature.yearly': 'Température (annuel)',
  'chart.humidity': 'Humidité',
  'chart.humidity.ext': 'Humidité Ext.',
  'chart.humidity.history': 'Historique d’humidité',
  'chart.humidity.daily': 'Humidité (quotidien)',
  'chart.humidity.monthly': 'Humidité (mensuel)',
  'chart.humidity.yearly': 'Humidité (annuel)',
  'meteorology.temperature': 'Température',
  'meteorology.humidity': 'Humidité',
  'dashboard.sub.buildings': 'Sous-bâtiments',
  'building.characteristics': 'Caractéristiques générales',
  'city.madrid': 'Madrid',
  'city.barcelona': 'Barcelone',
  'city.paris': 'Paris',
  'floor.without.client': 'Sans client',
  'building.floor.ground': 'Rez-de-chaussée',
  'building.floor.1': 'Étage 1',
  'building.floor.2': 'Étage 2',
  'building.floor.3': 'Étage 3',
  'building.floor.4': 'Étage 4',
  'building.floor.5': 'Étage 5',
  'building.floor.6': 'Étage 6',
  'building.floor.7': 'Étage 7',
  'building.blueprints': 'Plans',
  'building.reports': 'Rapports',
  'building.directory': 'Répertoire',
  'building.portfolio': 'Portefeuille',
  'building.portfolio.group': 'Portfolio',
  'home.no-buildings': 'Aucun bâtiment ne vous est encore attribué.',
  'home.no-portfolio': "Il n'y a pas encore de portefeuille.",
  'aiteaview.login-sso': 'Se connecter avec SSO',
  'administration.search': 'Rechercher...',
  'user.forgot-password.enter.email.error':
    'Veuillez saisir votre adresse e-mail',
  'user.forgot-password.invalid.email.error': 'Adresse e-mail invalide',
  'user.forgot-reset-password.forgot.password.error':
    'Erreur de mot de passe oublié',
  'user.forgot-password.forgot.password.success.body':
    'Si vous êtes un utilisateur de la plateforme, vous recevrez un e-mail contenant un lien pour réinitialiser votre mot de passe',
  'user.forgot-password.forgot.password.success.title': 'Mot de passe oublié',
  'user.forgot-reset-password.body.title': 'LA MAGIE EST DANS LES DÉTAILS',
  'user.forgot-reset-password.body.body.one':
    'Si vous êtes un utilisateur de la plateforme, vous recevrez un e-mail contenant un lien pour réinitialiser votre mot de passe.',
  'user.forgot-reset-password.body.body.two':
    'Veuillez utiliser votre e-mail pour réinitialiser votre mot de passe.',
  'user.forgot-reset-password.body.body.three':
    "Si vous n'êtes pas membre, veuillez",
  'user.forgot-reset-password.body.body.register': 'vous inscrire',
  'edi.nodata.available': 'Pas de mesure disponible',
  'edi.connection.error': 'Erreur de connexion, réessayez',
  'edi.connection.timeout': "Délai d'attente dépassé, réessayez",
  'edi.portfolio.market.value': 'Valeur marchande',
  'edi.portfolio.total.surface.area': 'Surface totale',
  'edi.portfolio.assets.number': "Nombre d'actifs",
  'edi.portfolio.assets.number.unit': 'actifs',
  'edi.nodata.to.download': 'Pas de donnees a telecharger',
  'edi.download.minimum.period':
    "Le telechargement n'est pas possible pour des periodes inferieures a un mois",
  'city.madrid.directory': 'Répertoire de Madrid',
  'city.barcelona.directory': 'Répertoire de Barcelone',
  'building.floor': 'Étage',
  'building.level': 'Niveau',
  'building.floor.download.blueprint': 'Télécharger',
  'building.floor.file': 'Fichier',
  'building.client': 'Client',
  'building.no_floors': 'Aucun étage disponible.',
  'building.no_icon': "Pas d'icône",
  'card.consumption.total': 'Total',
  'card.consumption.heating': 'Chauffage',
  'card.consumption.cooling': 'Refroidissement',
  'building.heatmap': 'Carte thermique',
  'disclaimer.title': 'Avis Important',
  'disclaimer.button.accept': 'Accepter',
  'disclaimer.error.get':
    "Erreur lors de la vérification du statut de l'avertissement légal",
  'disclaimer.error.accept':
    "Erreur lors de l'enregistrement de l'acceptation de l'avertissement légal",
  'client.apps.reports': 'Rapports',
  'client.apps.heatmap': 'Cartes thermiques',
  'client.apps.intranet': 'Intranet',
  'client.apps.climate': 'Climat',
  'client.apps.lightning': 'Éclairage',
  'administration.buildings.without.img': 'Sans image',
  'building.blueprint.implantation': 'Implantation',
  'building.blueprint.architecture': 'Architecture',
  'building.blueprint.coordination.imp': 'Coordination Impl.',
  'building.blueprint.coordination.arch': 'Coordination Arch.',
  'building.apps': 'Apps',
  'contact.with.us': 'Contactez-nous',
  'building.blueprint.coordination': 'Coordination',
  'administration.settings.autodesk.title': 'Autodesk',
  'administration.settings.set.period.time':
    'Définir la période de téléchargement Autodesk (heures)',
  'administration.settings.set.period.time.visualization':
    'Définir la période de visualisation Autodesk (jours)',
  'administration.accounts.autodesk_id': 'ID Autodesk',
  'administration.settings.footprint_objective': "Objectif d'empreinte carbone",
  'administration.settings.report_config': 'Paramètres avancés du rapport',
  'administration.settings.manage_reports': 'Gérer les rapports',
  'settings.report.lang.es': 'Espagnol',
  'settings.report.lang.fr': 'Français',
  'settings.report.lang.cat': 'Catalan',
  'settings.report.lang.en': 'Anglais',
  'edi.dashboard.widgets.edit-chart': 'Modifier le graphique',
  'date.sunday': 'Dimanche',
  'date.monday': 'Lundi',
  'date.tuesday': 'Mardi',
  'date.wednesday': 'Mercredi',
  'date.thursday': 'Jeudi',
  'date.friday': 'Vendredi',
  'date.saturday': 'Samedi',
  'date.january': 'Janvier',
  'date.february': 'Février',
  'date.march': 'Mars',
  'date.april': 'Avril',
  'date.may': 'Mai',
  'date.june': 'Juin',
  'date.july': 'Juillet',
  'date.august': 'Août',
  'date.september': 'Septembre',
  'date.october': 'Octobre',
  'date.november': 'Novembre',
  'date.december': 'Décembre',
  'dashboard.hide_reports_config': 'Masquer la configuration des rapports',
  'dashboard.show_reports_config': 'Afficher la configuration des rapports',
  'administration.widgets.flows': 'Flux',
  'administration.widgets.deepki': 'Deepki',
  'administration.widgets.med': 'MED',
  'administration.widgets.metasys_barcelona': 'Metasys Barcelona',
  'administration.widgets.metasys_madrid': 'Metasys Madrid',
  'administration.widgets.aitea_building': 'Bâtiment Aitea',
  'administration.reports.title-1': 'Titre 1',
  'administration.reports.title-2': 'Titre 1.1',
  'administration.reports.title-3': 'Titre 1.1.1',
  'administration.reports.title-4': 'Titre 1.1.1.1',
  'administration.reports.title-5': 'Titre 1.1.1.1.1',
  'administration.reports.title-6': 'Titre 1.1.1.1.1.1',
  'administration.reports.text-body': 'Corps du texte',
  'administration.reports.table-chart-title':
    'Titre des tableaux et graphiques',
  'building.basement': 'Sous-sol',
  'building.semi_basement': 'Demi-sous-sol',
  'building.garage': 'Garage',
  'building.attic': 'Grenier',
  'building.mezzanine': 'Mezzanine',
  'chart.unconsolidated-data': 'Mes en cours',
  'chart.previous-year': 'Année précédente',
  'chart.no-data': 'Aucune donnée à afficher',
  'chart.loading': 'Chargement...',
  'chart.target': 'Objectif 2030',
  'chart.maximum': 'Maximum',
  'chart.minimum': 'Minimum',
  'chart.co2-rite': 'Valeur maximale de référence du CO2',
  'edi.widgets.chart-edi': 'Graphique AiteaView',
  'administration.building.no_certificates': 'Aucun certificat attribué',
  'administration.permission.admin': 'Administrateur',
  'administration.widgets.placement.carousel': 'Carrousel',
  'administration.widgets.placement.information': 'Information',
  'administration.widgets.placement.directory': 'Répertoire',
  'administration.widgets.placement.data': 'Données',
  'administration.group.all': 'Tous',
  'administration.group.building': 'Bâtiment',
  'administration.group.subbuilding': 'Sous-bâtiment',
  'administration.group.client': 'Client',
  'chart.humidity-rite': 'Maximum Décret Royal 486/1997',
  'chart.humidity-min-rite': 'Minimum Décret Royal 486/1997',
  'cosbim.parameters.not-configured':
    'Ce bâtiment ne dispose pas encore de dossiers configurés.',
  'cosbim.documents.not.found': 'Aucun document dans ce module',
  'cosbim.open.all.nodes': 'Ouvrir tous les dossiers',
  'cosbim.close.all.nodes': 'Fermer tous les dossiers',
  'cosbim.pdf': 'PDF',
  'cosbim.cad': 'CAD',
  'cosbim.docuware.no-ue-code':
    'Ce bâtiment n’a pas de code d’unité économique, qui est ce qui l’identifie dans DocuWare. Sans lui, ses documents ne peuvent pas être affichés.',
  'cosbim.building.not-found':
    'Bâtiment introuvable. Vérifiez le lien : cet écran n’affiche que des bâtiments.',
  'cosbim.docuware.forbidden':
    'Vous n’avez pas la permission de voir les documents de ce bâtiment.',
  'cosbim.docuware.unreachable':
    'Pas de connexion avec DocuWare. Les dossiers sont affichés vides jusqu’au retour du service.',
  'cosbim.docuware.error':
    'DocuWare a renvoyé une erreur. Les dossiers sont affichés vides, mais ils peuvent bien contenir des documents.',
  'cosbim.docuware.downloading': 'Téléchargement...',
  'cosbim.docuware.view': 'Voir le document',
  'cosbim.docuware.download': 'Télécharger le document',
  'cosbim.docuware.not_viewable':
    'Ce document ne peut pas être affiché dans le navigateur ; utilisez l’icône pour le télécharger.',
  'cosbim.docuware.viewer.close': 'Fermer',
  'cosbim.docuware.viewer.unsupported':
    'Ce document ne peut pas s’afficher ici ; téléchargez-le pour l’ouvrir.',
  'cosbim.docuware.download_failed': 'Le document n’a pas pu être téléchargé',
  'cosbim.docuware.view_failed': 'Le document n’a pas pu être ouvert',
  'cosbim.docuware.retry': 'Réessayer',
  'cosbim.docuware.truncated':
    'Il y a plus de documents que DocuWare ne renvoie en une fois, il peut donc en manquer dans la liste.',
  'cosbim.docuware.folder.loading': 'Chargement des documents...',
  'cosbim.docuware.folder.unavailable': 'Non disponible',
  'cosbim.bim.load_failed': 'Les documents BIM360 n’ont pas pu être chargés.',
  'cosbim.bim.cache_unavailable': 'Cache Autodesk non disponible.',
  'cosbim.bim.download_failed': 'Le fichier BIM360 n’a pas pu être téléchargé.',
  'cosbim.node.without_name': 'Sans nom',
  'parameters.hidden.success': 'Dossier masqué',
  'parameters.visible.success': 'Dossier visible',
  'documents.empty.links':
    'Ce bâtiment n’a aucun dossier de type Link, les seuls qui se configurent ici.',
  'documents.empty.no_cosbim': 'Ce bâtiment n’a aucun module COSBIM associé.',
  'building.autodesk-id-missing':
    "Le bâtiment n'a pas d'ID Autodesk configuré.",
  'alarms.no.registred': 'Aucune alarme enregistrée',
  'alarms.non.critical': 'Non critique',
  'alarms.critical': 'Critique',
  'alarms.without.message': 'Sans message',
  'assistant.ask': 'Demande-moi ce que tu veux...',
  'building.contacts': 'Contacts',
  'building.information': 'Informations sur le bâtiment',
  'building.services': 'Services',
  'building.validations': 'Validations',
  'building.contacts.last.update': 'Dernière mise à jour',
  'building.create.service': 'Créer un nouveau service',
  'building.create.validation': 'Créer une nouvelle validation',
  'building.edit.service': 'Modifier le service',
  'building.edit.validation': 'Modifier la validation',
  'building.service.name': 'Nom',
  'building.service.description': 'Description',
  'building.validation.service': 'Service',
  'building.validation.field': 'Champ',
  'building.validation.type': 'Type',
  'building.form.cups': '+ Ajouter un CUPS',
  'building.form.ue_code': '+ Ajouter un code UE',
  'building.subbuildings.ue_codes': 'Codes UE des sous-bâtiments',
  'building.generate.reports': 'Générer le rapport',
  'building.report.consumption.only.building.or.client.message':
    "Le rapport de consommation ne peut être généré qu'à partir d'un bâtiment ou d'un client",
  'consumption.report.send': 'Envoyer',
  'date.range.invalid': 'Plage de dates invalide',
  'consumption.report.missing_data':
    'Données du bâtiment ou du client manquantes',
  'consumption.report.success': 'Rapport généré avec succès',
  'consumption.report.generating': 'Génération du rapport...',
  'consumption.report.no_cups':
    "Ce rapport ne peut pas être généré pour ce bâtiment car il s'agit d'un bâtiment basse tension.",
  'consumption.report.email_sent':
    'Rapport envoyé avec succès par courrier électronique.',
  'building.ue_code': 'Code UE',
  'building.tipology': 'Typologie',
  'building.status': 'Statut',
  'building.parent_space': 'Ville',
  'building.basic_data': 'Données de base',
  'building.tipology.monousuario': 'Mono-utilisateur',
  'building.tipology.multiusuario': 'Multi-utilisateur',
  'building.tipology.en_construction': 'En construction',
  'building.status.requerimiento': 'Demande',
  'building.status.explotacion': 'Exploitation',
  'building.status.fin_de_obra': 'Fin de chantier',
  'building.contact.tecnico': 'Technicien Associé',
  'building.contact.csm': 'CSM Associé',
  'building.contact.fm': 'Facility Manager',
  'building.contact.name': 'Nom',
  'building.contact.email': 'Email',
  'building.contact.phone': 'Téléphone',
  'building.contact.company': 'Entreprise',
  'building.contact.24h.ssgg': 'Contact 24h Services généraux SSGG',
  'building.contact.24h.pci': 'Contact PCI 24h',
  'building.contact.24h.vertical_transport': 'Téléphone transport vertical 24h',
  'building.contact.24h.medium_voltage': 'Contact 24h moyenne tension',
  'building.contact.24h.security_phone': 'Téléphone sécurité 24h',
  'building.contact.24h.vigilance': 'Surveillance 24h',
  'building.contact.24h': '24 heures',
  'building.phone.hours': 'Téléphone 24 heures',
  'building.phone.hours.other': 'Téléphone 24 heures (autre)',
  'building.contact.technician': 'Technicien',
  'building.contact.coordinator': 'Coordinateur',
  'building.phone.other': 'Autre téléphone',
  'building.shift': 'Équipe',
  'building.notes': 'Observations',
  'administration.services.tittle.delete': 'Voulez-vous supprimer ce service ?',
  'administration.contacts.tittle.delete':
    'Êtes-vous sûr de vouloir supprimer ce contact ?',
  'administration.settings.verification.title': 'Validations contacts',
  'administration.settings.verification.enabled':
    'Activer le système de vérification',
  'administration.settings.verification.max.days':
    'Jours maximum de confirmation',
  'administration.settings.verification.periodicity.days':
    'Périodicité des validations (jours)',
  'building.contacts.add.technician': 'Ajouter un contact',
  'building.contacts.delete.contact': 'Supprimer le contact',
  'technician.created.success': 'Contact créé avec succès',
  'service.updated.success': 'Modifié avec succès',
  'service.deleted.success': 'Supprimé avec succès',
  'service.created.success': 'Créé avec succès',
  'administration.validations.tittle.delete':
    'Êtes-vous sûr de vouloir supprimer cette validation ?',
  'email.verification.success': 'Email vérifié avec succès',
  'email.verification.error': "Impossible de vérifier l'email",
  'email.verification.go_to_login': 'Aller au login',
  'administration.contacts.permissions.title': 'Autorisations des contacts',
  'administration.contacts.permissions.read': 'Lecture',
  'administration.contacts.permissions.write': 'Écriture',
  'administration.contacts.permissions.validate': 'Validation',
  'building.validate.data': 'Valider les données',
  'administration.settings.validation.period.days':
    'Périodicité de validation des données (jours)',
  'assistant.loading': "Chargement de l'assistant...",
  'assistant.location.portfolio': 'Vous consultez le portefeuille de [name].',
  'assistant.location.city': 'Vous consultez les bâtiments de [name].',
  'assistant.location.building': 'Vous consultez [name].',
  'building.data_validated': 'Validé',
  'building.last_validated_at': 'Date de dernière validation',
  'building.last_validated_by': 'Validé par',
  'carbon.footprint.message':
    'Émissions opérationnelles des Scopes 1 + 2 + 3 selon le Greenhouse Gas Protocol (GHG Protocol) dans sa méthodologie officielle de calcul market-based.',
  'building.contact.role': 'Rôle',
  'contacts.download.title': 'Générer un Excel des Contacts',
  'contacts.download.select.buildings':
    'Sélectionnez les bâtiments à inclure :',
  'contacts.download.select.all': 'Tout sélectionner',
  'contacts.download.download': 'Télécharger',
  'contacts.download.send': 'Envoyer',
  'contacts.download.no.buildings': 'Sélectionnez au moins un bâtiment',
  'contacts.download.success': 'Excel des contacts téléchargé avec succès',
  'contacts.download.email.sent':
    'Liste des contacts envoyée avec succès par e-mail',
  'parameters.name.duplicated':
    'Un dossier avec ce nom existe deja au meme niveau.',
  'parameters.name.too_long':
    'Le chemin complet depasse 200 caracteres. Raccourcissez le nom.',
  'parameters.path.preview': 'Chemin complet',
  'parameters.node_type': 'Type de parametre',
  'parameters.node_type.container': 'Conteneur',
  'parameters.node_type.docuware': 'Conteneur DocuWare',
  'parameters.node_type.autodesk': 'Conteneur AutoDesk',
  'parameters.node_type.link': 'Lien',
  'parameters.node_type.link_hint':
    'Un Conteneur ne fait que regrouper : pour afficher des documents, choisissez Conteneur DocuWare. Un lien naccepte pas de sous-dossiers.',
  'parameters.node_type.link_has_children':
    'Conversion en lien impossible : le dossier a des sous-dossiers.',
  'parameters.node_type.drop_filter':
    'Changer le type supprimera le filtre DocuWare.',
  'parameters.docuware.cabinet': 'Armoire',
  'parameters.docuware.cabinet_required': 'Choisissez une armoire.',
  'parameters.docuware.cabinet_unavailable':
    'La liste des armoires na pas pu etre chargee.',
  'parameters.docuware.clase_doc': 'Classe doc',
  'parameters.docuware.subclase_doc': 'Sous-classe doc',
  'parameters.docuware.tipo_doc': 'Type doc',
  'parameters.filter.add': 'Ajouter',
  'parameters.filter.placeholder': 'Saisissez une valeur puis Entree',
  'parameters.filter.any_of':
    'Avec plusieurs valeurs dans un même champ, les documents de n’importe laquelle d’entre elles s’affichent. Les champs doivent tous être respectés.',
  'parameters.docuware.values_empty':
    'Ces valeurs n’apparaissent aujourd’hui dans aucun document ; ce peut être une faute de frappe ou rien de chargé avec cette valeur : {values}',
  'parameters.docuware.filter_empty':
    'Un filtre sans valeur afficherait tous les documents du batiment.',
  'parameters.docuware.checking': 'Verification dans DocuWare...',
  'parameters.docuware.ok': 'Le filtre renvoie {count} documents.',
  'parameters.docuware.no_match':
    'Larmoire contient {count} documents, mais aucun ne correspond a ce filtre.',
  'parameters.docuware.field_empty': 'Cest ce champ qui vide le filtre.',
  'parameters.docuware.empty_scope':
    'Il ny a pas encore de documents dans ce perimetre, le filtre ne peut pas etre verifie.',
  'parameters.docuware.unreachable': 'Pas de connexion a DocuWare.',
  'parameters.docuware.gateway_error': 'DocuWare a renvoye une erreur.',
  'parameters.docuware.no_ue_code':
    'Le batiment na pas de code dunite economique.',
  'parameters.docuware.saves_anyway': 'Le dossier est enregistre malgre tout.',
  'parameters.docuware.save_anyway': 'Enregistrer quand meme',
  'parameters.docuware.save_unchecked': 'Enregistrer sans vérifier',
  'parameters.reorder.up': 'Monter',
  'parameters.reorder.down': 'Descendre',
  'parameters.empty': 'Il ny a pas encore de dossiers.',
  'parameters.empty.search': 'Aucun parametre ne correspond a la recherche.',
  'parameters.created.success': 'Dossier cree',
  'parameters.updated.success': 'Dossier mis a jour',
  'parameters.deleted.success': 'Dossier supprime',
  'administration.widgets.plans': 'Plans',
  'administration.accounts.tittle.edit.user': 'Modifier utilisateur',
  'client.reports.floors.title': 'Sélectionnez les étages',
  'client.reports.floors.empty': 'Aucun étage disponible pour ce client.',
  'client.reports.floors.required': 'Sélectionnez au moins un étage',
  'client.reports.dashboard.required': 'Sélectionnez un rapport',
  'client.reports.confirm': 'Confirmer',
  'client.reports.cancel': 'Annuler',
  'client.reports.generate.pdf': 'Générer PDF',
  'client.reports.send.email': 'Envoyer par courriel',
  'client.reports.selected.floors': 'Étages sélectionnés',
  'date.range.same.year':
    'Seuls les mois de la même année peuvent être sélectionnés',
  'client.reports.generating': 'Génération du rapport...',
  'client.reports.pdf.success': 'Rapport généré avec succès',
  'client.reports.email.success': 'Rapport envoyé à votre adresse e-mail',
  'client.reports.email.sending': 'Envoi du rapport...',
  'client.reports.pdf.error': 'Le rapport n’a pas pu être généré',
  'client.reports.floors.resolving': 'Préparation des étages...',
  'client.reports.floors.error':
    "Les étages du rapport n'ont pas pu être résolus",
  'client.reports.module.on-floor': "À l'étage",
  'client.reports.module': 'Module',
  'widgets.type.date': 'Date',
  'widgets.type.apps-carousel': "Carrousel d'applications",
  'widgets.type.apps-directory': "Répertoire d'applications",
  'widgets.type.portfolio-summary': 'Résumé du portfolio',
  'widgets.type.weather': 'Météo',
  'widgets.type.air-quality': "Qualité de l'air extérieur",
  'widgets.type.metric': 'Métrique',
  'widgets.type.app': 'Application',
  'widgets.kind.url': 'Lien (url)',
  'widgets.kind.data': 'Données (data)',
  'widgets.kind.custom': 'Personnalisé (custom)',
  'widgets.kind.custom-app': 'Application avec interface propre',
  'widgets.behavior.link': 'Lien',
  'widgets.behavior.blueprint': 'Plans',
  'widgets.behavior.reports': 'Rapports',
  'widgets.behavior.contacts': 'Contacts',
  'widgets.behavior.contacts_download': 'Téléchargement des contacts',
  'widgets.behavior.cosbim': 'COSBIM',
  'widgets.behavior.ocas': 'OCAs',
  'widgets.behavior.assistant': 'Assistant',
  'widgets.config.behavior': 'Comportement',
  'widgets.config.node_types': 'Proposé dans',
  'widgets.config.required_permission': 'Permission requise',
  'widgets.node_type.portfolio': 'Portfolio',
  'widgets.node_type.space': 'Espace ou ville',
  'widgets.node_type.building': 'Bâtiment',
  'widgets.node_type.subbuilding': 'Sous-bâtiment',
  'widgets.node_type.client': 'Client',
  'widgets.public': 'Public',
  'widgets.public.help':
    "Tout utilisateur ayant accès à l'entité le voit, sans avoir besoin de la permission du widget. Il doit tout de même être assigné à chaque entité.",
  'administration.ocas.filter.status.danger_warning': 'Dates en rouge et jaune',
  'administration.ocas.docuware_pending':
    "La source des documents (DocuWare) n'est pas encore configurée : en attendant, les installations s'affichent « En attente » et sans document.",
  'administration.ocas.building.no_document': 'Sans document',
  'administration.ocas.building.last_sync': 'Données DocuWare du',
  'administration.ocas.building.sync_error':
    'Impossible de se connecter à DocuWare. Les dernières données disponibles sont affichées.',
  'administration.ocas.tittle.delete':
    'Êtes-vous sûr de vouloir supprimer cette installation ?',
  'administration.ocas.month': 'mois',
  'administration.ocas.months': 'mois',
  'administration.ocas.building.status.not_applicable': 'N/A',
  'administration.ocas.date.not_applicable': 'N/A',
  'administration.ocas.date.pending': 'En attente',
  'administration.ocas.building.status.pending': 'En attente',
  'administration.settings.ocas.title': 'Alertes par e-mail des OCA',
  'administration.settings.ocas.enabled': 'Activer les alertes des OCA',
  'administration.settings.ocas.expiry_days':
    "Jours de préavis avant l'inspection",
  'administration.settings.ocas.periodicity_days':
    'Jours entre les alertes répétées',
  'administration.settings.ocas.help':
    "Lorsque les alertes sont activées, AiteaView envoie chaque jour un e-mail aux FM pour chaque bâtiment dont les inspections arrivent à échéance, et aux FM et au technicien du bâtiment en cas d'inspections non approuvées.",
  'administration.settings.ocas.save': 'Enregistrer les alertes des OCA',
  'administration.settings.notification.ocas_updated':
    'Alertes des OCA mises à jour',
  /* aiteaview_end_trans */
  /* aiteaassistant_start_trans */
  'example.example': 'Exemple',
  'assistant.title': 'Assistant Aitea',
  'assistant.say.something': 'Demandez-moi quelque chose',
  'assistant.action.delete': 'Supprimer',
  'assistant.action.speaker': 'Connecter au haut-parleur',
  'assistant.action.microphone': 'Connecter au microphone',
  'assistant.action.microphonestop': 'Mettre le micro en pause',
  'assistant.action.attach': 'Joindre des documents',
  'assistant.action.alerts': 'Ajouter des alertes',
  'assistant.action.settings': 'Paramètres',
  'assistant.action.logout': 'Se déconnecter',
  'assistant.menu': 'Assistant',
  'assistant.initial.message': 'Bonjour à nouveau',
  'assistant.greeting':
    "Bonjour, [name]. Je suis votre Assistant, l'outil qui permet d'accéder de manière rapide et simple aux informations clés du portefeuille de Colonial, d'améliorer les KPI de maintenance, de gagner du temps dans les tâches quotidiennes et de soutenir le contrôle de la qualité de la maintenance opérationnelle.",
  'assistant.file.download': 'Télécharger le document demandé',
  'assistant.file.error':
    "Erreur lors du téléchargement du fichier. Les fichiers ne peuvent être téléchargés qu'une seule fois. Pour le consulter à nouveau, vous devez en refaire la demande.",
  'assistant.user.pronoun': 'Moi',
  'assistant.delete.disclaimer':
    'Êtes-vous sûr de vouloir supprimer la conversation ?',
  'assistant.delete.title': "Supprimer l'historique de la conversation",
  'assistant.yesterday': 'Hier',
  'assistant.today': "Aujourd'hui",
  'assistant.thinking': 'En train de réfléchir...',
  'assistant.listening': 'Écoute...',
  'assistant.playing': 'Lecture...',
  'assistant.playback.speed': 'Vitesse de lecture',
  'assistant.playback.close': 'Fermer le lecteur',
  'assistant.finish': 'Terminer',
  'assistant.reasoning': 'Raisonnement',
  'assistant.feedback.title': 'Comment était cette réponse ?',
  'assistant.feedback.comment.placeholder': 'Commentaire (facultatif)',
  'assistant.feedback.submit': 'Envoyer',
  'permissions.global.assistant.use': "Utiliser l'assistant",
  'permissions.global.assistant.use.description':
    "Interroger l'assistant et consulter son propre historique de discussions.",
  'permissions.global.assistant.chatbot': 'Assistant en mode chatbot',
  'permissions.global.assistant.chatbot.description':
    "Utiliser l'assistant comme chatbot : il répond aux questions.",
  'permissions.global.assistant.agentic': 'Assistant en mode agentique',
  'permissions.global.assistant.agentic.description':
    "Utiliser l'assistant en mode agentique : en plus de répondre, il exécute des actions.",
  /* aiteaassistant_end_trans */
  /* dashboards_start_trans */
  'menu.dashboardList': 'Liste des tableaux de bord',
  'dashboard.name': 'Nom du Dashboard',
  'dashboard.description': 'Description du Dashboard',
  'dashboard.widgets': 'Widgets',
  'dashboard.widgets.chart-line': 'Graphique linéaire',
  'dashboard.widgets.chart-area': 'Graphique en aires',
  'dashboard.widgets.chart-column': 'Graphique en colonnes',
  'dashboard.widgets.table': 'Tableau',
  'dashboard.widgets.counter': 'Compteur',
  'dashboard.widgets.title': 'Titre',
  'dashboard.widgets.text': 'Texte',
  'dashboard.widgets.chart-abscissa': 'Graphique d’abscisses',
  'dashboard.widgets.chart-pie': 'Graphique à sections',
  'dashboard.widgets.chart-bar-electric-use': 'Graphique à barres %',
  'dashboard.widgets.electric-use.types': 'Données à afficher',
  'dashboard.widgets.electric-use.power': 'Force',
  'dashboard.widgets.electric-use.lighting': 'Éclairage',
  'dashboard.widgets.electric-use.hvac': 'Climatisation',
  'dashboard.widgets.electric-use.validation-error':
    'Vous devez choisir au moins un type de donnée et le regroupement des données.',
  'dashboard.widgets.electric-use.no-entity':
    'Ce widget doit être ouvert depuis un bâtiment, un sous-bâtiment ou un client.',
  'dashboard.widgets.electric-use.no-module':
    "Cette entité n'a pas le module Electricidad Uso avec le regroupement choisi.",
  'dashboard.widgets.create': 'Créer un nouveau widget',
  'dashboard.widgets.name': 'Nom du widget',
  'dashboard.widgets.database': 'Base de données',
  'dashboard.widgets.collector': 'collecteur',
  'dashboard.widgets.counter.type': 'Type de valeur',
  'dashboard.widgets.counter.type.max': 'Valeur maximale',
  'dashboard.widgets.counter.type.last': 'Dernière valeur',
  'dashboard.widgets.content': 'Contenu du widget',
  'dashboard.widgets.content.edit': 'Modifier le contenu',
  'dashboard.widgets.save': 'Enregistrer',
  'dashboard.widgets.delete': 'Supprimer',
  'dashboard.widgets.cancel': 'Annuler',
  'dashboard.widgets.add': 'Ajouter',
  'dashboard.widgets.delete-confirmation':
    'Êtes-vous sûr de vouloir supprimer le widget ?',
  'dashboard.widgets.close-confirmation':
    'Êtes-vous sûr de vouloir quitter ? Les modifications non enregistrées seront perdues.',
  'dashboard.widgets.select': 'Sélectionner le type de widget',
  'dashboard.widgets.select.columns': 'Colonnes maximales',
  'dashboard.widgets.select-type.electrical': 'Électrique',
  'dashboard.widgets.select-type.water': 'Eau',
  'dashboard.widgets.select-type.gas': 'Gaz',
  'dashboard.widgets.select-type.thermal-cold': 'Thermique (froid)',
  'dashboard.widgets.select-type.thermal-hot': 'Thermique (chaud)',
  'dashboard.widgets.select-type.thermal-total': 'Thermique total',
  'dashboard.widgets.select-type.temperature': 'Température',
  'dashboard.widgets.select-type.ext-temperature': 'Température Ext.',
  'dashboard.widgets.select-type.humidity': 'Humidité',
  'dashboard.widgets.select-type.ext-humidity': 'Humidité Ext.',
  'dashboard.widgets.select-type.co2': 'CO2',
  'dashboard.widgets.select-type.ext-co2': 'CO2 Ext.',
  'dashboard.widgets.select-type.cala': "Qualité de l'air",
  'dashboard.widgets.select-type.occupation-percentage':
    "Pourcentage d'Occupation",
  'dashboard.widgets.select-group.hourly': 'Horaire',
  'dashboard.widgets.select-group.daily': 'Quotidien',
  'dashboard.widgets.select-group.monthly': 'Mensuel',
  'dashboard.widgets.select-group.yearly': 'Annuel',
  'dashboard.widgets.select-type.title-warning':
    'Avertissement sur le type de regroupement',
  'dashboard.widgets.select-type.body-warning':
    'Le type de données que vous avez sélectionné ne contient que des données horaires, le widget sera vide.',
  'dashboard.widgets.date.from': 'De',
  'dashboard.widgets.date.to': 'À',
  'dashboard.widgets.text.header': 'Widget de texte',
  'dashboard.widgets.title.header': 'Widget de titre',
  'dashboard.widgets.module.title-error': 'Erreur du module',
  'dashboard.widgets.module.body-error':
    "Le collecteur {collectorType} {collectorGroupingType} du widget {widgetName} n'existe pas dans {representName}.",
  'dashboard.widgets.multi.edit-chart': 'Modifier le graphique',
  'dashboard.widgets.multi.content': 'Création de graphique d’abscisse',
  'dashboard.widgets.multi.title': 'Titre',
  'dashboard.widgets.multi.footer': 'Pied de page',
  'dashboard.widgets.multi.components': 'Composants',
  'dashboard.widgets.multi.component': 'Composant',
  'dashboard.widgets.multi.edit': 'Modifier',
  'dashboard.widgets.multi.delete': 'Supprimer',
  'dashboard.widgets.multi.edit-component': 'Modifier le composant',
  'dashboard.widgets.multi.component-name': 'Nom du composant',
  'dashboard.widgets.multi.chart-type': 'Type de graphique',
  'dashboard.widgets.multi.source': 'Source',
  'dashboard.widgets.multi.color': 'Couleur',
  'dashboard.widgets.multi.lines': 'Lignes',
  'dashboard.widgets.multi.columns': 'Colonnes',
  'dashboard.widgets.multi.line': 'Ligne',
  'dashboard.widgets.multi.min': 'Minimum',
  'dashboard.widgets.multi.mean': 'Moyenne',
  'dashboard.widgets.multi.max': 'Maximum',
  'dashboard.widgets.multi.default': 'Par défaut',
  'dashboard.widgets.multi.stacked-percentage':
    'Graphique empilé avec pourcentages',
  'dashboard.widgets.multi.total-grouped':
    'Graphique des totaux groupés par composant',
  'dashboard.widgets.multi.last-year-compare':
    'Comparer avec l’année précédente',
  'dashboard.widgets.donut.content': 'Création de graphique en sections',
  'dashboard.widgets.collector-type': 'Type de données',
  'dashboard.widgets.collector-grouping-type': 'Regroupement de données',
  'dashboard.widgets.edi.template-warning':
    'Mode édition, ce Dashboard est un modèle de rapport, pour voir les données accédez-y depuis EDI.',
  'dashboard.widgets.edi.template-error':
    'Ce tableau de bord est un modèle de rapport, accédez-y depuis l’EDI pour visualiser les données.',
  'dashboards.create-dashboard': 'Créer',
  'dashboards.create-button': 'Nouveau tableau de bord',
  'dashboards.create-dashboard.title': 'Créer un nouveau tableau de bord',
  'dashboards.new-dashboard-name': 'Nom du tableau de bord',
  'dashboards.modify-dashboard': 'Modifier',
  'dashboards.update-dashboard-name': 'Mettre à jour le nom',
  'dashboard.widgets.table.title': 'Tableau',
  'dashboard.widgets.table.columns': 'Colonnes',
  'dashboard.widgets.table.add.column': 'Ajouter une colonne',
  'dashboard.widgets.table.rows': 'Lignes',
  'dashboard.widgets.table.add.row': 'Ajouter une ligne',
  'dashboard.widgets.table.footer': 'Pied de page',
  'dashboard.widgets.table.configure': 'Configurer',
  'dashboard.widgets.table.type': 'Type',
  'dashboard.widgets.table.type.horizontal': 'Horizontal',
  'dashboard.widgets.table.type.vertical': 'Vertical',
  'dashboard.widgets.table.color.first.row': 'Couleur de la première ligne',
  'dashboard.widgets.table.color.other.rows': 'Couleur autres lignes',
  'dashboard.widgets.table.color.other.cols': 'Couleur autres colonnes',
  'dashboard.widgets.table.compare.hide.months': 'Cacher des mois',
  'dashboard.widgets.table.validation.stats-required':
    'Vous devez sélectionner au moins une option dans Autres lignes ou Autres colonnes',
  'dashboard.widgets.table.color.conditioned': 'Couleur conditionnelle',
  'dashboard.widgets.table.condition': 'Condition',
  'dashboard.widgets.table.others.rows': 'Autres lignes',
  'dashboard.widgets.table.others.columns': 'Autres colonnes',
  'dashboard.widgets.table.compare.last.year': 'Comparer à l’année dernière',
  'dashboard.widgets.table.max': 'Maximum',
  'dashboard.widgets.table.minimun': 'Minimum',
  'dashboard.widgets.table.average': 'Moyenne',
  'dashboard.widgets.table.configuration': 'Configurer',
  'dashboard.widgets.table.title-placeholder': 'Titre',
  'dashboard.widgets.table.footer-placeholder': 'Pied de page',
  'dashboard.widgets.table.condition-placeholder':
    'Ex : valeur > 27 || valeur < 17',
  'dashboard.create.report_properties': 'Propriétés du rapport',
  'dashboard.create.report_description': 'Description',
  'dashboard.create.report_format':
    'Ajouter une mise en forme de rapport (page de couverture, table des matières, en-tête et pied de page)',
  'dashboard.create.report_image1': 'Image 1 (à droite du pied de page)',
  'dashboard.create.report_image2': 'Image 2 (à droite de l’en-tête)',
  'dashboard.create.report_image3': 'Image 3 (centre de la couverture)',
  'dashboard.report-image.low-resolution.title': 'Résolution d’image faible',
  'dashboard.report-image.low-resolution.body':
    'La résolution de l’image sélectionnée est inférieure à celle recommandée et peut nuire à sa qualité d’affichage dans le rapport. Nous vous recommandons d’utiliser une image de plus haute résolution.',
  'dashboard.create.report_clients': 'Visible pour les clients',
  'dashboard.create.report_disclaimer': 'Texte de clause de non-responsabilité',
  'dashboard.pdf': 'PDF',
  'dashboard.generate.pdf': 'Générer',
  'dashboard.mail': 'Mail',
  'dashboard.send.mail': 'Envoyer',
  'dashboard.send_mail': 'Envoyer à mon e-mail',
  'dashboard.close': 'Fermer',
  'dashboard.create.add_cover_page': 'Ajouter une couverture',
  'dashboard.create.add_index_page': 'Ajouter un index',
  'dashboard.create.add_header': 'Ajouter un en-tête',
  'dashboard.create.add_footer': 'Ajouter un pied de page',
  'dashboard.create.report_disclaimer_two':
    'Texte de clause de non-responsabilité 2',
  'dashboard.title.data.quality': 'Qualité des données',
  'dashboard.title.forced.points': 'Points en forçage manuel',
  'dashboard.title.points.outside.rite': 'Points hors RITE',
  'dashboard.title.vrvs.alarms': 'VRVs avec alarme de filtre',
  'dashboard.title.data.frequency':
    'Analyse de la fréquence de collecte des données',
  'dashboard.title.abnormal.electrical.electrical':
    'Consommations électriques anormales',
  'dashboard.title.startup.recommendation': 'Recommandation de démarrage',
  'dashboard.create.corporate_text': 'Texte corporatif',
  'dashboard.dashboards.delete-confirmation':
    'Êtes-vous sûr de vouloir supprimer ce rapport ?',
  'dashboard.save.success': 'Le tableau de bord a été enregistré avec succès.',
  'dashboard.table.total': 'Total',
  'dashboard.table.total.accumulated': 'Total Cumulé',
  'dashboard.table.min': 'Minimum',
  'dashboard.table.avg': 'Moyenne',
  'dashboard.table.stat': 'Statistique',
  'dashboard.table.year': 'Année',
  'dashboard.table.month': 'Mois',
  'dashboard.table.value': 'Valeur',
  'dashboard.table.floor': 'Étage',
  'dashboard.table.module': 'Module',
  'dashboard.month.short.jan': 'Janv',
  'dashboard.month.short.feb': 'Fév',
  'dashboard.month.short.mar': 'Mars',
  'dashboard.month.short.apr': 'Avr',
  'dashboard.month.short.may': 'Mai',
  'dashboard.month.short.jun': 'Juin',
  'dashboard.month.short.jul': 'Juil',
  'dashboard.month.short.aug': 'Aoû',
  'dashboard.month.short.sep': 'Sept',
  'dashboard.month.short.oct': 'Oct',
  'dashboard.month.short.nov': 'Nov',
  'dashboard.month.short.dec': 'Déc',
  'dashboard.level.title1': 'Titre 1',
  'dashboard.level.title1_1': 'Titre 1.1',
  'dashboard.level.title1_1_1': 'Titre 1.1.1',
  'dashboard.level.title1_1_1_1': 'Titre 1.1.1.1',
  'dashboard.level.title1_1_1_1_1': 'Titre 1.1.1.1.1',
  'dashboard.level.title1_1_1_1_1_1': 'Titre 1.1.1.1.1.1',
  'dashboard.groupType.building': 'Édifice',
  'dashboard.groupType.client': 'Client',
  'dashboard.groupType.subbuilding': 'Sous-bâtiment',
  'dashboard.groupType.spaces': 'Ville',
  'dashboard.groupType.portfolio': 'Portfolio',
  'dashboard.upload.select-image': 'Sélectionner une image',
  'dashboard.date.range.warning':
    'Il n’est pas possible de générer des rapports avec une plage de dates supérieure à un an.',
  'electric.consumption': 'Consommation électrique',
  'water.cons': "Consommation d'eau",
  'gas.cons': 'Consommation de gaz',
  'districlima.cons': 'Consommation thermique (totale)',
  'chart.temp': 'Température',
  'districlima.cons.cold': 'Consommation thermique (froid)',
  'districlima.cons.hot': 'Consommation thermique (chaud)',
  'chart.humid': 'Humidité',
  'chart.humid.ext': 'Humidité extérieure',
  'metric.occup': 'Pourcentage d’occupation',
  'temp.ext': 'Température extérieure',
  'dashboard.generator': 'Générateur de rapports',
  'dashboard.report.headless.loading': 'Chargement des données du rapport...',
  'dashboard.report.headless.rendering':
    'Génération des graphiques du rapport...',
  'dashboard.report.headless.generating': 'Création du PDF du rapport...',
  'dashboard.report.headless.done': 'Rapport généré.',
  'dashboard.report.headless.timeout-error':
    'Le délai maximal de génération du rapport a été dépassé. Réessayez ou réduisez la plage de dates.',
  'dashboard.report.headless.error': 'Impossible de générer le PDF du rapport.',
  'dashboard.widgets.image': 'Image',
  'dashboard.widgets.image.empty': "Ce widget n'a pas d'image.",
  'dashboard.widgets.image.file': 'Image du widget',
  'dashboard.widgets.image.help':
    "JPEG, PNG, WebP ou GIF, jusqu'à 5 Mo. Elle s'adapte à la taille du widget sans se déformer.",
  'dashboard.widgets.image.invalid-type':
    'Format non pris en charge. Utilisez JPEG, PNG, WebP ou GIF.',
  'dashboard.widgets.image.too-large':
    "L'image dépasse la taille maximale de 5 Mo.",
  'dashboard.widgets.image.required': 'Sélectionnez une image.',
  /* dashboards_end_trans */
};
